import { render } from "./EmployeeModal.vue?vue&type=template&id=002493e9&scoped=true"
import script from "./EmployeeModal.vue?vue&type=script&lang=js"
export * from "./EmployeeModal.vue?vue&type=script&lang=js"

import "./EmployeeModal.vue?vue&type=style&index=0&id=002493e9&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002493e9"]])

export default __exports__